import React, { useMemo, useState } from "react";
import { Container, Row, Col, Form } from "react-bootstrap";
import nftData from "../data/nfts";
import NFTCard from "./NFTCard";
import "../styles/NFTList.css";

const priceToNumber = (p) => {
  if (!p) return 0;
  return parseFloat(p.replace("ETH", "").trim()) || 0;
};

const NFTList = () => {
  const [query, setQuery] = useState("");
  const [sortBy, setSortBy] = useState("");

  const filtered = useMemo(() => {
    let list = [...nftData];

    // Filter by search query
    if (query.trim()) {
      const q = query.toLowerCase();
      list = list.filter(
        (n) =>
          n.name.toLowerCase().includes(q) ||
          (n.artist || "").toLowerCase().includes(q)
      );
    }

    // Sort
    if (sortBy === "name-asc") {
      list.sort((a, b) => a.name.localeCompare(b.name));
    }
    if (sortBy === "price-low") {
      list.sort((a, b) => priceToNumber(a.priceETH) - priceToNumber(b.priceETH));
    }
    if (sortBy === "price-high") {
      list.sort((a, b) => priceToNumber(b.priceETH) - priceToNumber(a.priceETH));
    }

    return list;
  }, [query, sortBy]);

  return (
    <Container className="nft-list-container">
      <Row className="nft-list-filters g-3 align-items-end mb-3">
        <Col md={6}>
          <Form.Label className="fw-semibold">Search</Form.Label>
          <Form.Control
            placeholder="Search by name or artist…"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
          />
        </Col>
        <Col md={6}>
          <Form.Label className="fw-semibold">Sort</Form.Label>
          <Form.Select value={sortBy} onChange={(e) => setSortBy(e.target.value)}>
            <option value="">— No sorting —</option>
            <option value="name-asc">Name (A→Z)</option>
            <option value="price-low">Price (Low→High)</option>
            <option value="price-high">Price (High→Low)</option>
          </Form.Select>
        </Col>
      </Row>

      <Row xs={1} sm={2} md={3} className="g-4 nft-card-row">
        {filtered.map((nft) => (
          <Col key={nft.id}>
            <NFTCard nft={nft} />
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default NFTList;
